<article class="content-block-tips section-inset-y bg-secondary text-light">
  <div class="container">
    <header class="text-max-width mx-auto text-center my-5">
      <h1 class="h2 pb-4">{{ block.title }}</h1>
      <p class="type-body-sm" *ngIf="block.text" [innerHTML]="block?.text"></p>
      <div class="mb-3" *ngIf="block?.button?.routerLink || block?.button?.url">
        <a class="button button--light mt-4" [routerLink]="block.button.routerLink" *ngIf="block.button.routerLink">
          {{ block.button?.text }}
        </a>
        <a class="button button--light mt-4" [href]="block.button.url" *ngIf="!block.button.routerLink">{{ block.button?.text }}</a>
      </div>
    </header>
    <main class="content-block-tips__main mt-3 container container-size-md">
      <dl class="content-block-tips__row__list">
        <div itemscope class="content-block-tips__item" *ngFor="let tip of block.tips">
          <dt class="h2 content-block-tips__item__title">
            <span>{{ tip.title }}</span>
          </dt>
          <dd class="content-block-tips__item__image">
            <figure *ngIf="tip.imageUrl">
              <img [src]="tip.imageUrl | resize: 600:undefined:tip.imageAnchor" [alt]="tip.title" />
            </figure>
          </dd>
          <dd class="content-block-tips__item__desc type-body-xs">
            <div [innerHTML]="tip.text"></div>
          </dd>
        </div>
      </dl>
    </main>
  </div>
</article>
